// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-wrapper {
  height: 450px;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: 0 4px 16px var(--shadow);
  padding: 16px;
  padding-bottom: 30px;
}

.chart-header-row {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 8px;
}

.chart-title {
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  width: 100%;
  color: var(--chart-title-color);
  margin-bottom: 0;
  margin-top: 0;
  letter-spacing: 0.2px;
}

.chart-download {
  position: absolute;
  right: 0;
  top: 0;
}

.chart-download-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--text-secondary);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, opacity 0.15s ease;
}

.chart-download-trigger:hover:not([aria-disabled="true"]) {
  background: var(--hover);
  color: var(--primary);
}

/* Dimmed state for roles without the download_charts permission (demo),
   and while an export is in flight — still visible so the feature is
   discoverable, just visibly inert. aria-disabled (not the native
   \`disabled\` attribute) keeps this a normal, hoverable element, which is
   what makes the plain :hover rule below actually fire. */
.chart-download-trigger[aria-disabled="true"] {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Same look as the map tooltip (components/Tooltip.css's .map-tooltip) —
   same tokens, radius, shadow, weight — just anchored under the button
   instead of following the cursor. Visibility is controlled entirely by
   BarChart's tooltipVisible state (conditional render), so it appears
   the instant it mounts — no CSS transition/delay to fight with. */
.chart-download-tooltip {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 1000;
  padding: 6px 10px;
  border-radius: var(--radius-sm);
  background: var(--tooltip-bg);
  color: var(--tooltip-text);
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  pointer-events: none;
  box-shadow: 0 4px 12px var(--shadow);
}

.chart-download-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 5;
  min-width: 150px;
  padding: 6px;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: 0 10px 28px var(--shadow-lg);
}

.chart-download-menu button {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--text-primary);
  font-size: 13px;
  text-align: left;
  cursor: pointer;
}

.chart-download-menu button:hover:not(:disabled) {
  background: var(--hover);
}

.chart-download-menu button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.table-scroll {
  overflow-x: auto;
  overflow-y: auto;
  flex: 1 1;
  min-width: 0;
  max-width: 100%;
}

.table {
  margin: 0;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 10px;
  overflow: hidden;
  table-layout: auto;
  width: max-content;
  min-width: 100%;
  color: var(--text-primary);
}

.table thead th {
  background-color: var(--table-header-bg);
  color: var(--table-header-text);
  font-weight: 600;
}

.table td,
.table th {
  background-color: transparent;
  padding: 10px 0px;
  vertical-align: middle;
  line-height: 1.2;
}

.table tbody tr {
  transition: background-color 0.2s ease;
}

.table tbody tr:hover td {
  background: var(--hover);
}

.table th:first-child,
.table td:first-child {
  padding-left: 20px;
}

.table th:last-child,
.table td:last-child {
  padding-right: 20px;
}

.table thead th:first-child {
  border-top-left-radius: 10px;
}

.table thead th:last-child {
  border-top-right-radius: 10px;
}

.table tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

.table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

.table-outer {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  overflow-x: auto;
  overflow-y: auto;
  box-sizing: border-box;
}

.chart-wrapper,
.table-scroll,
.table-outer {
  min-width: 0;
}

/* =========================================================
   RESPONSIVE
   ========================================================= */
@media (max-width: 768px) {
  .chart-wrapper {
    height: 360px;
  }
  .chart-title {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .chart-wrapper {
    height: 300px;
    padding-bottom: 20px;
  }
  .chart-title {
    font-size: 17px;
  }
  .table th:first-child,
  .table td:first-child {
    padding-left: 12px;
  }
  .table th:last-child,
  .table td:last-child {
    padding-right: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/charts.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,oCAAoC;EACpC,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,eAAe;EACf,uEAAuE;AACzE;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;;;0DAI0D;AAC1D;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;mEAImE;AACnE;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;EACP,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;8DAE8D;AAC9D;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,kBAAkB;EACpB;EACA;;IAEE,mBAAmB;EACrB;AACF","sourcesContent":[".chart-wrapper {\n  height: 450px;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  background: var(--card-bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: 0 4px 16px var(--shadow);\n  padding: 16px;\n  padding-bottom: 30px;\n}\n\n.chart-header-row {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  margin-bottom: 8px;\n}\n\n.chart-title {\n  font-size: 22px;\n  font-weight: 600;\n  text-align: center;\n  width: 100%;\n  color: var(--chart-title-color);\n  margin-bottom: 0;\n  margin-top: 0;\n  letter-spacing: 0.2px;\n}\n\n.chart-download {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.chart-download-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--card-bg);\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, opacity 0.15s ease;\n}\n\n.chart-download-trigger:hover:not([aria-disabled=\"true\"]) {\n  background: var(--hover);\n  color: var(--primary);\n}\n\n/* Dimmed state for roles without the download_charts permission (demo),\n   and while an export is in flight — still visible so the feature is\n   discoverable, just visibly inert. aria-disabled (not the native\n   `disabled` attribute) keeps this a normal, hoverable element, which is\n   what makes the plain :hover rule below actually fire. */\n.chart-download-trigger[aria-disabled=\"true\"] {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Same look as the map tooltip (components/Tooltip.css's .map-tooltip) —\n   same tokens, radius, shadow, weight — just anchored under the button\n   instead of following the cursor. Visibility is controlled entirely by\n   BarChart's tooltipVisible state (conditional render), so it appears\n   the instant it mounts — no CSS transition/delay to fight with. */\n.chart-download-tooltip {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 1000;\n  padding: 6px 10px;\n  border-radius: var(--radius-sm);\n  background: var(--tooltip-bg);\n  color: var(--tooltip-text);\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  pointer-events: none;\n  box-shadow: 0 4px 12px var(--shadow);\n}\n\n.chart-download-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 5;\n  min-width: 150px;\n  padding: 6px;\n  background: var(--card-bg);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  box-shadow: 0 10px 28px var(--shadow-lg);\n}\n\n.chart-download-menu button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 13px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.chart-download-menu button:hover:not(:disabled) {\n  background: var(--hover);\n}\n\n.chart-download-menu button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.table-scroll {\n  overflow-x: auto;\n  overflow-y: auto;\n  flex: 1;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.table {\n  margin: 0;\n  border-collapse: separate;\n  border-spacing: 0;\n  border-radius: 10px;\n  overflow: hidden;\n  table-layout: auto;\n  width: max-content;\n  min-width: 100%;\n  color: var(--text-primary);\n}\n\n.table thead th {\n  background-color: var(--table-header-bg);\n  color: var(--table-header-text);\n  font-weight: 600;\n}\n\n.table td,\n.table th {\n  background-color: transparent;\n  padding: 10px 0px;\n  vertical-align: middle;\n  line-height: 1.2;\n}\n\n.table tbody tr {\n  transition: background-color 0.2s ease;\n}\n\n.table tbody tr:hover td {\n  background: var(--hover);\n}\n\n.table th:first-child,\n.table td:first-child {\n  padding-left: 20px;\n}\n\n.table th:last-child,\n.table td:last-child {\n  padding-right: 20px;\n}\n\n.table thead th:first-child {\n  border-top-left-radius: 10px;\n}\n\n.table thead th:last-child {\n  border-top-right-radius: 10px;\n}\n\n.table tbody tr:last-child td:first-child {\n  border-bottom-left-radius: 10px;\n}\n\n.table tbody tr:last-child td:last-child {\n  border-bottom-right-radius: 10px;\n}\n\n.table-outer {\n  width: 100%;\n  max-width: 900px;\n  margin: 0 auto;\n  overflow-x: auto;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.chart-wrapper,\n.table-scroll,\n.table-outer {\n  min-width: 0;\n}\n\n/* =========================================================\n   RESPONSIVE\n   ========================================================= */\n@media (max-width: 768px) {\n  .chart-wrapper {\n    height: 360px;\n  }\n  .chart-title {\n    font-size: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .chart-wrapper {\n    height: 300px;\n    padding-bottom: 20px;\n  }\n  .chart-title {\n    font-size: 17px;\n  }\n  .table th:first-child,\n  .table td:first-child {\n    padding-left: 12px;\n  }\n  .table th:last-child,\n  .table td:last-child {\n    padding-right: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
